import type { TMediaAnalysisProgress } from 'app/queries/media/createFetchMediaAnalysisProgressQueryFn';

export const MEDIA_ANALYSIS_TIMEOUT_MS = 5 * 60 * 1000;

export type TMediaAnalysisOutcome =
  | { status: 'pending' }
  | { status: 'done'; duration: number }
  | { status: 'noAudio' }
  | { status: 'failed' }
  | { status: 'timedOut' }
  | { status: 'unreachable' };

const resolveSettledOutcome = (progress: TMediaAnalysisProgress | undefined): TMediaAnalysisOutcome => {
  if (!progress || progress.analysisStatus === 'PENDING') {
    return { status: 'pending' };
  }
  if (progress.duration > 0) {
    return { status: 'done', duration: progress.duration };
  }
  if (progress.analysisStatus === 'FAILED') {
    return { status: 'failed' };
  }
  if (progress.analysisStatus === 'CORE_READY' || progress.analysisStatus === 'COMPLETE') {
    return { status: 'noAudio' };
  }
  if (progress.legacyJob?.returnvalue) {
    const duration = Number(progress.legacyJob.returnvalue.duration) || 0;
    return duration > 0 ? { status: 'done', duration } : { status: 'noAudio' };
  }
  if (progress.legacyJob?.failedReason) {
    return { status: 'failed' };
  }
  return { status: 'pending' };
};

export const resolveMediaAnalysisOutcome = (
  progress: TMediaAnalysisProgress | undefined,
  elapsedMs: number,
): TMediaAnalysisOutcome => {
  const outcome = resolveSettledOutcome(progress);
  if (outcome.status === 'pending' && elapsedMs >= MEDIA_ANALYSIS_TIMEOUT_MS) {
    return { status: 'timedOut' };
  }
  return outcome;
};
